import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import LanguageSelect from '../modules/HomepageSettings/LanguageSelect';
import HomepageSettings from '../modules/HomepageSettings';

class HpSettingsPage extends Component {
  render() {
    return (
      <Layout>
        <Container>
          <h1>Nastavení homepage</h1>
          <LanguageSelect />
          <HomepageSettings />
        </Container>
      </Layout>
    );
  }
}

export default HpSettingsPage;



// WEBPACK FOOTER //
// ./src/pages/HpSettingsPage.js